var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"backcall","adaptive":true,"height":"auto"},on:{"before-open":_vm.beforeOpen,"before-close":_vm.beforeClose}},[_c('div',{staticClass:"p-4"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }